import { BaseToolbarNavPageLayout } from './baseLayoutViews';

/**
 * A Backbone wrapper for a React page. This acts as a compatibility layer between
 * our Backbone app + navigation system and newer React pages.
 */
export const ReactPageWrapper = BaseToolbarNavPageLayout.extend({
    // Marker class so global chrome (e.g. the rebrand warning banner) can offset
    // these React pages, which render their own toolbar instead of a .toolbarnav.
    className: 'react_page',
    use_transitions: true,
    renderFunction: () => {},

    initialize: function (options = {}) {
        $.extend(this, options);
        this.toolbarnav_class = null; // the React page should implement its own toolbarnav
    },

    render: function () {
        window.mountReactJSX(this.el, () => this.renderFunction());
    },

    onClose: function () {
        window.unmountReact(this.el);
    }
});
